import { forwardRef, useImperativeHandle, useState } from 'react';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { Button } from '@mui/material';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SnackBarComponent = forwardRef((props, ref) => {
    const [snackbarInfo, setSnackBarInfo] = useState({
        open: false,
        severity: '',
        label: '',
        needsAction: false
    });
    const { open, severity, label, needsAction } = snackbarInfo;

    useImperativeHandle(ref, () => ({
        openSnackBar: ({ label, severity }) => {
            setSnackBarInfo({
                ...snackbarInfo,
                open: true,
                severity: severity,
                label: label
            });
        }
    }));

    const handleClose = () => {
        setSnackBarInfo({
            ...snackbarInfo,
            open: false
        });
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert
                severity={severity}
                action={
                    needsAction ? (
                        <Button
                            sx={{
                                color: '#FFFFFF'
                            }}
                            size="small">
                            Go Back
                        </Button>
                    ) : null
                }>
                {label}
            </Alert>
        </Snackbar>
    );
});

export default SnackBarComponent;
